import * as React from "react";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "security-app/components/common/Modal";
import { useModalContext } from "common/contexts";
import { useUpdateSecurityEvent } from "security-app/hooks/useSecurityEventsAPI";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
function ConfirmOwnerRemove() {
  const { t } = useTranslation("enterprise_security_events");
  const { entity: securityEvent, setEntity, setModal } = useModalContext();
  const { updateSecurityEvent, updatingSecurityEvent } = useUpdateSecurityEvent();
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const onConfirm = async () => {
    const payload = {
      owner: null,
      notes: securityEvent.notes,
      status: securityEvent.status
    };
    await updateSecurityEvent({ id: securityEvent.event_id, data: payload });
    sendEventActionTelemetry("REMOVE_OWNER", false);
    setModal(null);
    setEntity(null);
  };
  const onCancel = () => {
    setModal(null);
    setEntity(null);
  };
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      onConfirm,
      confirmDisabled: updatingSecurityEvent,
      isLoading: updatingSecurityEvent,
      confirmText: t("confirm_owner_remove.confirm_text"),
      onCancel,
      title: t("confirm_owner_remove.title")
    },
    /* @__PURE__ */ React.createElement("p", null, t("confirm_owner_remove.description"))
  );
}
export default ConfirmOwnerRemove;
